<template>
  <div id="app">
    <nav class="navbar navbar-expand p-0">
      <div class="container">
        <a class="navbar-brand p-0" href="https://ivsz.hu/" target="_blank"></a>
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="https://ivsz.hu/" target="_blank">
              <span class="home-icon"></span>
            </a>
          </li>
          <li class="nav-item d-none d-sm-flex align-items-center">
            <router-link class="nav-link" to="/">Felajánlások</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <slider></slider>
    <div class="container p-5" id="main-container">
      <router-view/>
    </div>
    <footer>
      <div class="container h-100">
        <div class="row h-100">
          <div class="col col-sm-4 h-100 d-flex align-items-center">
            <a href="https://ivsz.hu/" target="_blank" class="text-white">ivsz.hu - Minden jog fenntartva</a>
          </div>
          <div class="col col-sm-4 h-100 d-flex align-items-center justify-content-center">
            Szakmai partner:
            <img src="@/assets/http_white_tr.png" height="40" style="height: 40px; margin: 15px">
          </div>
          <div class="col col-sm-4 h-100 d-flex align-items-center justify-content-end">
            <a href="#" class="back-to-top text-white text-right">Ugrás az oldal tetejére</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Slider from '@/components/Slider.vue';

export default {
  name: 'App',
  components: {
    Slider
  },
}
</script>

<style lang="sass">
  $primary: #3b549e;
  $body-bg: #f8f8f8;
  $font-family-base: "Open Sans", Helvetica, Arial, sans-serif;

  @import 'node_modules/bootstrap/scss/bootstrap';
</style>

<style>
  .article-title {
    display: block;
    font-size: 1.875em;
    text-transform: uppercase;
    font-weight: 600;
    color: #3b549e;
    line-height: 1.3em;
    margin-bottom: .3em;
  }
</style>

<style scoped>
  nav {
    position: fixed;
    z-index: 42 !important;
    top: 0;
    left: 0;
    width: 100%;
    background: #ffffff;
    border-bottom: 4px solid rgba(2, 30, 52, 0.2);
    z-index: 2;
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding-box;
    background-clip: padding-box;
    height: 70px;
    box-sizing: content-box;
  }
  .navbar-brand {
    width: 213px;
    height: 70px;
    background: url(assets/ivsz_logo.svg) no-repeat 50% 50%;
    background-size: contain;
  }
  .nav-link {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 15px;
  }
  .home-icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: url(assets/home.svg) no-repeat;
    background-size: 50%;
    background-position: 50% 50%
  }
  #main-container {
    min-height: 400px;
    margin-top: -77px;
    background-color: white;
    position: relative;
    z-index: 2;
  }
  footer {
    background: #508ac8;
    color: #fff;
    text-transform: uppercase;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-size: 0.75em;
  }
  footer, footer .col {
    min-height: 70px;
  }
</style>